import { c } from '../../theme';

// The Executive Overview's gauge — a half donut, which is NOT the 270° arc
// ArcGauge draws.
//
// The two are different components in the old app as well: the Board and the
// VP page use the three-quarter arc with a notch on the rim, and /exec uses
// `PrototypeGauge`, a 180° arc with the figure sitting inside its mouth and a
// status line under it. Drawing this page with the other gauge is the single
// most visible way it reads as a different product, so the geometry here is
// copied from that component rather than approximated: the arc is one path,
// `M22 92 A66 66 0 0 1 154 92`, whose length is 207.4, and the fill is a dash
// array along it.
//
// Sizes are the old app's too — 212px across for a primary driver, 176px for
// a supporting metric — and they are a CAP, not a width. Every font inside the
// SVG is in viewBox units, so an uncapped gauge scales its own type with the
// column it sits in; that is the regression !176 fixed on the other gauge.

const PATH = 'M22 92 A66 66 0 0 1 154 92';
const ARC_LENGTH = 207.4;

const clamp01 = (x) => Math.max(0, Math.min(1, x));

export default function ExecGauge({ value, status, statusDelta, color, fill = 0, compact = false, direction, title }) {
  const width = compact ? 176 : 212;
  const stroke = compact ? 13 : 15;
  const dash = `${clamp01(fill) * ARC_LENGTH} ${ARC_LENGTH}`;

  return (
    <div style={{ ...s.box, maxWidth: `${width}px`, margin: compact ? '5px auto 0' : '6px auto 0' }}>
      <svg viewBox={compact ? '0 0 176 104' : '0 0 176 114'} role="img"
        aria-label={title || `${value} ${status || ''}`.trim()} style={s.svg}>
        <path d={PATH} fill="none" stroke={c.border} strokeWidth={stroke} />
        <path d={PATH} fill="none" stroke={color} strokeWidth={stroke} strokeDasharray={dash} />
      </svg>
      <div style={{ ...s.face, paddingBottom: compact ? 0 : '2px', gap: compact ? 0 : '6px' }}>
        <div style={s.valueRow}>
          <span style={{ ...s.value, fontSize: compact ? '24px' : '30px' }}>{value}</span>
          {direction && (
            <span title="Direction against the comparison period"
              style={{ ...s.direction, fontSize: compact ? '12px' : '14px' }}>{direction}</span>
          )}
        </div>
        {(status || statusDelta) && (
          <div style={{ ...s.status, fontSize: compact ? '10px' : '12px', color }}>
            {status}{status && statusDelta ? ' · ' : ''}{statusDelta}
          </div>
        )}
      </div>
    </div>
  );
}

const s = {
  box:       { position: 'relative', width: '100%' },
  svg:       { width: '100%', display: 'block' },
  face:      { position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'flex-end' },
  valueRow:  { display: 'flex', alignItems: 'baseline', gap: '6px' },
  value:     { fontWeight: 750, letterSpacing: '-0.5px', lineHeight: 1, color: c.text,
    fontVariantNumeric: 'tabular-nums' },
  direction: { fontWeight: 750, color: c.textFaint },
  status:    { fontWeight: 750, letterSpacing: '0.06em' },
};
